angular.module 'zc.commonApi'

.factory 'InterestTree', ($q, FacadeV2) ->
  class InterestTree
    @find: (paths, params) ->
      FacadeV2.request "/apikeys/#{paths.apikey}/interest_trees",
        params: params
      .then (res) ->
        res.data
  InterestTree



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/facade/interest_trees.service.coffee